/**
 * O access token vive só na memória do JS — some no reload, de propósito.
 * O refresh token está num cookie httpOnly que este código não consegue ler
 * (e um XSS também não). Ao recarregar a página a sessão é reidratada por
 * POST /auth/refresh, que manda o cookie sozinho.
 */
let accessToken: string | null = null;

/** Chamado quando o refresh falha de vez: a sessão acabou. */
type SessionLostHandler = () => void;
let onSessionLost: SessionLostHandler = () => {};

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

/**
 * Quem está operando esta sessão em NOSSO nome, quando o painel interno
 * entrou na conta para dar suporte. Vazio numa sessão normal.
 *
 * Mora aqui junto do access token, e pelo mesmo motivo: os dois vêm da
 * mesma resposta de `/auth/refresh` e têm o mesmo tempo de vida. O valor
 * chega no CORPO, não num claim — decodificar JWT no front seria dar ao
 * cliente a responsabilidade de interpretar credencial.
 */
let impersonatedBy: string | null = null;

export function getImpersonatedBy(): string | null {
  return impersonatedBy;
}

export function setImpersonatedBy(ator: string | null): void {
  impersonatedBy = ator;
}

export function setSessionLostHandler(handler: SessionLostHandler): void {
  onSessionLost = handler;
}

export function notifySessionLost(): void {
  accessToken = null;
  impersonatedBy = null;
  onSessionLost();
}
